module.exports = __webpack_public_path__ + "img/br-flag.png";